import React from 'react'
import './Info.scss'

const Info = ({fieldLabel, placeholder, isTitle}) => {
    return (
        <div className="infoContainer">
            {isTitle ? (<p>{fieldLabel}</p>) : (<h2>{fieldLabel}</h2>)}
            <span>{placeholder}</span>
        </div>
    )
}

export default Info;